import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

/** Mirrors `CredentialsCheckResult` in `admin-console-api/src/handlers/fusion-credentials-check.ts`. */
export type FusionCredentialsCheck =
  | {
      ok: true;
      region: string;
      organizationId: number;
      licenseOrgIds: string[];
      orgMismatch: boolean;
      missingTeamIds: string[];
    }
  | {
      ok: false;
      reason: 'credentials-missing' | 'ims-rejected' | 'fusion-rejected';
      status?: number;
    }
  | { ok: false; reason: 'org-not-reachable'; organizationId: number };

/** Runs on click only: each check mints a token, so it is not polled. */
export function useCheckFusionCredentialsMutation(
  clientId: string | undefined,
  fusionConfigId: string,
): UseMutationResult<FusionCredentialsCheck, Error, void> {
  const api = useApiClient();
  return useMutation({
    mutationFn: async () => {
      if (!api || !clientId) {
        throw new Error('useCheckFusionCredentialsMutation: api client unavailable');
      }
      return api.get<FusionCredentialsCheck>(
        `/v1/clients/${clientId}/fusion-configs/${fusionConfigId}/credentials-check`,
      );
    },
  });
}
